import React from 'react'
//@ts-ignore
import s from './TwoLineParams.module.scss'

export type TwoLineParamsT = {

    children?: any,
}

export const TwoLineParams = ({ ...props }) => {
    const { children } = props;



    return (
        <div className={s.wrap}>
            {!!children.length && children.map((component: any) => {
             
                return (<div className={s.component} key={component.key} >  {component}</div>)
            })}
            {!children.length && <div className={s.component} >  {children}</div>}
        </div>
    )
}
